import axios from 'axios';
import store from '../store';

//Set defaults
axios.defaults.maxRedirects = 5;


// Axios headers in case defaults need to be overwritten
let config = {
    headers:{
        "Accept": "application/json",
    },
};

//functions available after import of this file
/**
 * Example import: import recorded from "<PATH>/Recorded.js"
 * Example uses:
 * ASYNC FUNCTION: let response = await trace.get("/samples", { with:'tests' });
 * or
 * REGULAR FUNCTION: recorded.get("/samples", { with:'tests' }).then(response => { console.log(response) });
 *
 */

export default {

    get(route, data = {}, headers = null){
        data.key = store.getters.trace_api_token;
        headers = (headers) ? headers : config.headers;
        return axios.get(store.getters.trace_api + route, {
            headers,
            params: data
        }).then(response => {
            return response;
        })
    },
    post(route, data = {}, headers = null){
        data.key = store.getters.trace_api_token;
        headers = (headers) ? headers : config.headers;
        return axios.post(store.getters.trace_api + route, data, headers).then(response => {
            return response;
        })
    }
}